<template>
    <div>
        <MdTitleRegInfo  
            v-bind:RegistrationInfo="{}"  
            v-bind:titlePrefix="$t('initialization.iapptypes.appoInfo')"            
            v-bind:titleRef="'titleElementAppointmentType'">
        </MdTitleRegInfo>

         <div class="row">
            <div class="col-12">               
                <p class="iSetupLabel">
                    <i class="ikon med-help"></i>
                    {{ $t('initialization.iapptypes.msg1') }} <b>{{ $t('Shared.Save') }}</b> {{ $t('initialization.iapptypes.msg2') }}
                </p>
                <div class="row">
                    <div class="col-sm-12 col-md-3">                      
                        <MdButton
                            v-bind:Label="$t('InitialConf.AddAppType')" 
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddAppType"
                            v-bind:Name="'btn_add_iuser'">
                        </MdButton>
                    </div>

<!--<div v-bind:class="'col-sm-12 col-md-9 mb-4'">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group">
                                <input 
                                    type="text" 
                                    class="form-control"
                                    v-model="parameter.SearchCriteria"   
                                    @keyup.enter="SearchAppTypes"                            
                                >
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton 
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="SearchAppTypes">
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>

        <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

        <div class="flex-container">
              <div class="row">                
              
              <div class="col-md-3">
                 <MdCheckBox
                  v-bind:Label="$t('Shared.SelectAll')"
                  v-bind:Name="'SelectTableAll'"
                  v-bind:ClassProp="'AlignCheck mx-3'"
                  v-bind:CheckedValue="true"
                  v-bind:isReadOnly="this.items.length === 0"
                  v-bind:UncheckedValue="false"
                  v-model="UseSelectTableAll" 
                  v-on:change="onChangeSelectAll"                
               /> 
              </div>
              <div class="col-md-3 mt-3">
                <span class="tableSelectedItems"><span class="selItemsVal">{{ SelectedRecords }}</span> {{ $t('claimbatchList.item') }}<span v-if="SelectedRecords != 1">s</span> {{ $t('Shared.selected') }}</span>
              </div>  
             <div class="col-md-6">
                       <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                      <div class="input-group" dir="ltr">
                          <input 
                            type="text" 
                            class="form-control"
                            :dir="dirInput"
                            v-model="modelSearch"                          
                            @keyup.enter="FindinItems()"
                          >
                          <div class="input-group-append">
                              <MdButton 
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"                               
                                v-on:click="FindinItems"
                                 >
                              </MdButton>
                          </div>
                      </div>
                  </div>
             </div>
                  
          
                                     
              </div>
          </div>

         
        <MdTablePaginationClient 
            v-bind:fields="fields"
            v-bind:items="items"
            v-bind:totalRows="totalRows"              
            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
            v-bind:currentPage="currentPage"
            v-bind:perPage="perPage" 
            v-bind:SelectAll="UseSelectTableAll"             
            v-bind:pageOptions="pageOptions"
            :iconSelected="IconSelected"
            :editIconEvent="EditAppType"
            :onFiltered="onFiltered"               
            v-bind:VisibleEditIcon="true"                        
            :onRowSelected="onRowSelected"    
            :pageChanged="pageChanged"
            :RowClick="RowClicked"        
            :perPageFunction="PerPageFunction">                
        </MdTablePaginationClient>

        <!--<MdTablePaginationClient
              v-bind:fields="fields"           
              v-bind:items="items"
              v-bind:totalRows="totalRows"                    
              v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
              v-bind:currentPage="currentPage"
              v-bind:perPage="perPage"
              v-bind:SelectAll="UseSelectTableAll"
              v-bind:ShowDetails="true"
              v-bind:FieldsDate="FieldsDateArr"
              v-bind:pageOptions="pageOptions" 
              v-bind:viewIconEvent="ViewIcon"
              v-bind:Error="Error"
              v-bind:Warning="Warning"
              :onRowSelected="onRowSelected" 
              :onFiltered="onFiltered"
              :pageChanged="pageChanged"
              :RowClick="RowClicked"
              :perPageFunction="PerPageFunction">
            </MdTablePaginationClient>-->

     

        <div class="space-actions"></div>
        <div class="page-actions">
        
        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'◄'"
            v-bind:Name="'btnApptypeBack'"
            v-on:click="Back"
            v-bind:ClassProp="'mx-2'"/>

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'►'"
            v-on:click="Next"
            v-bind:Name="'btnApptypeNext'"
            v-bind:ClassProp="'mx-2'"/>  


        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="$t('Shared.Save')"
            v-bind:Name="'btnAppointmentType'"
            v-bind:ClassProp="'mx-2 btn-login'"/>
        </div>



    </div>
   

</template>

<script>
import { EventBus } from '@/event-bus.js';

export default {
  name: 'IniAppTypes',
  data(){
    return{
         parameter:{
            SearchCriteria:"",
            PageNumber : 0,
            PageSize:0,
        },
         fields:[
            { key: 'firstName', sortable: true, label: this.$t('Shared.FirstName'), class: 'text-rigth' },         
            { key: 'lastName', sortable: true, label: this.$t('Shared.LastName'), class: 'text-rigth' },  
            { key: 'selected', sortable: true, label: this.$t('Shared.selected'), class: 'text-rigth hidden' },         
            { key: 'recId', sortable: true, label: '', class: 'text-rigth hidden' },          
            { key: 'taxonomy', sortable: true, label: this.$t('Shared.Taxonomy'), class: 'text-rigth' }                   
        ],
        ShowMessageIsEmpty:false,
        items:[
            {firstName:"Juan",lastName:"Lopez Hernandez",recId:1,taxonomy:"Test1",selected:false},
            {firstName:"Julio",lastName:"Perez Rodriguez",recId:2,taxonomy:"Test2",selected:false},
            {firstName:"Maria",lastName:"Fernandez Acuña",recId:3,taxonomy:"Test3",selected:false},
            {firstName:"Olga",lastName:"Moreno Gonzalez",recId:4,taxonomy:"Test4",selected:false},
           
        ],
        SelectedRecords:0,
        UseSelectTableAll:false,
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        modelSearch:"",
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
    }
  },
  methods:{
    Next(){
        this.$router.push({ name:'ireviewsubmit'});
    },

    Back(){
        this.$router.push({ name:'inotes'}); 
    },
    FindinItems(){

    },
     onRowSelected(){ 
     this.SelectedRecords = 0;
     if(this.items.length > 0){
    for(var i = 0; i < this.items.length; i++){
      if(this.items[i].selected){
        this.SelectedRecords++;
      }
    }
     }
    },
    SelectAllRecords(){
      this.SelectedPage = this.items.length;
      this.wasSelectedAll = true;
    },
    EditAppType(){

    },

    IconSelected(){

    },

    onChangeSelectAll(v){
        if(v){
        this.SelectedRecords = this.items.length; 
        for(var i = 0 ; i < this.items.length; i++){
           this.$set(this.items[i], 'selected', true); 
        }
      }else{
        this.SelectedRecords = 0;
        for(var j= 0 ; j < this.items.length; j++){
           this.$set(this.items[j], 'selected', false); 
        }
      }
    },

    RowClicked(item){
        if(item.selected){      
          this.$set(item, 'selected', false);         
        }else{
          this.$set(item, 'selected', true);       
        }
        EventBus.$emit('rowClicked', item);
    },

    onFiltered(){

    },

    PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
        this.SearchAppTypes();   
    },

    pageChanged(page){
        this.currentPage = page;    
        this.SearchAppTypes();   
    },
    AddAppType(){

    },

    SearchAppTypes(){

    }
  },

  created(){
     EventBus.$on("rowClicked", function () {        
        this.SelectedRecords = 0;
            for(var i = 0; i < this.items.length; i++){
                if(this.items[i].selected){
                    this.SelectedRecords++;
                }
            }      
     }.bind(this));
  },
  mounted(){

  }   
};
</script>


